import { Injectable, OnDestroy } from '@angular/core';
import { fuseConfig } from 'app/fuse-config';
import { FuseConfig } from '@fuse/types';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { takeUntil } from 'rxjs/operators';
import { CompanyService } from '@fuse/services/company.service';
import { AuthService } from '../auth/auth.service';
import { timer } from 'rxjs';
import { Component, OnInit } from '@angular/core';
import { fuseAnimations } from '@fuse/animations';


import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot, Router } from '@angular/router';



@Injectable()
export class AdsService implements OnDestroy {
    private _unsubscribeAll: Subject<any>;


    routeParams: any;
    onProjectListChanged: BehaviorSubject<any>;
    onFiltersChanged: BehaviorSubject<any>;
    onChipsChanged: BehaviorSubject<any>;

    private CompanyId: any;
    public _fuseConfig: FuseConfig;

    constructor(private http: HttpClient, private _router: Router, private _companyService: CompanyService) {
        this._fuseConfig = fuseConfig;
        this.onFiltersChanged = new BehaviorSubject({});
        this._unsubscribeAll = new Subject();
        this._companyService.getActiveCompany().then(data => {
            this.CompanyId = data.id;
            //   console.log(this._adsService.project);
            //       //   console.log(this.projects)
        });
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
        this.routeParams = route.params;

        return new Promise<void>((resolve, reject) => {

            Promise.all([

                // this.getInternalAds()

            ])
                .then(
                    () => {
                        resolve();
                    }
                )
                .catch(err => Promise.reject(err))
                .then(() => {
                    this._router.navigate(['/home/results']);
                }, err => {
                    // this._router.navigate(['/home']);
                });
        });
    }

    public getInternalAds(
        companyId: number = this.CompanyId,
        limit: string = '20', orderBy: string = 'id', order: string = 'asc', type: string = 'internal',
        lang: string = localStorage.getItem('lang')
    ): Promise<any> {

        const params = {
            limit: limit,
            order_by: orderBy,
            order: order,
            type: type,
            lang: lang
        };

        return new Promise((resolve, reject) => {
            this.http.post(this._fuseConfig.api.url + '/portal/erp/' + companyId + '/project/listing', params)
                .pipe(takeUntil(this._unsubscribeAll))
                .subscribe(
                    response => {
                        this.onFiltersChanged.next(response);
                        resolve(response);
                    }, reject);
        });
    }

    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }


}
